import { create } from 'zustand';

export const createUrlParamsSlice = (set, get) => ({
  urlParams: null,
  setUrlParams: (urlParams) => set({ urlParams }),
});
